module.exports = __webpack_public_path__ + "static/media/gallImg.ba83a5dd.png";